/* ============================================
   QUOTE WORKSTATION — Quotes
   Asset: workstation-quotes.js
   Load dropdown, quote list, lock/unlock, and loadQuote
   ============================================ */
(function() {
  'use strict';
  var Q = window.QWS;
  if (!Q) return;
  var state = Q.state;
  var dom = Q.dom;
  var wrap = Q.wrap;
  var API = Q.API;
  var isAdmin = Q.isAdmin;
  var escHtml = Q.escHtml;
  var escAttr = Q.escAttr;
  var genId = Q.genId;
  var fmt = Q.fmt;
  var calculateDirect = Q.calculateDirect;
  var reversePoints = Q.reversePoints;
  var syncCustomSelect = Q.syncCustomSelect;
  /* CUSTOM_MARKETINGOPS_BY_CLAUDE (2026-07-24, DNI decoupling piece 3) — the raw-source →
     dropdown-option map (_SRC_TO_INQUIRY / mapInquirySource) was REMOVED with the Lead Source
     select it fed. The equivalent normalization now lives server-side, once, in rfq-worker
     lib/lead-signals.js (canonicalMethod) where every Marketing-Ops surface shares it — instead
     of a client copy that had to be kept in sync with the worker whitelist by hand. */
  var extractModel = Q.extractModel;
  var findItem = Q.findItem;

  /* ── Load Quote Dropdown ── */
  var loadBackdrop = wrap.querySelector('.rq-ws-bar__load-backdrop');
  function toggleLoadDropdown(open) {
    if (!dom.loadDropdown) return;
    dom.loadDropdown.classList.toggle('rq-ws-bar__load-dropdown--open', open);
    if (loadBackdrop) loadBackdrop.classList.toggle('rq-ws-bar__load-backdrop--open', open);
  }
  if (loadBackdrop) loadBackdrop.addEventListener('click', function() { toggleLoadDropdown(false); });
  dom.btnLoad.addEventListener('click', function(e) {
    e.stopPropagation();
    var isOpen = dom.loadDropdown.classList.contains('rq-ws-bar__load-dropdown--open');
    toggleLoadDropdown(!isOpen);
    if (!isOpen) {
      loadQuotesList();
      dom.loadSearch.focus();
    }
  });

  dom.loadSearch.addEventListener('input', function() {
    filterQuotesList(this.value.trim().toLowerCase());
  });

  /* CUSTOM_QWLOADSTREAM_BY_CLAUDE (Ryan 2026-10-10) — "Load existing" shows quotes as they arrive.
     It used to wait for ONE /rep-quotes call of up to 200 rows and show nothing until all had loaded.
     Now: (1) the other versions of the quote that is open come first, from /quote-chain (KV only, fast),
     so jumping -B -> -C is immediate; (2) the rest stream in pages of 25, newest first, each page
     clickable the moment it lands, with "Loading more..." at the bottom; (3) search filters whatever
     has loaded so far. state.quotesCache is only set once every page is in (other callers read it as
     the whole list). A reopen while it is still loading keeps the same run. */
  var _QW_PAGE = 25, _QW_MAX = 200, _qwLoadSeq = 0;
  var _qwVersions = null, _qwPartial = [], _qwLoading = false, _qwLoadErr = false;

  function _qwSearch() { return (dom.loadSearch && dom.loadSearch.value || '').trim().toLowerCase(); }
  function _qwMatches(quote, q) {
    if (!q) return true;
    var s = ((quote.reference || quote.ref || '') + ' ' + (quote.customer || '') + ' ' + (quote.customerCompany || '') + ' ' + (quote.customerEmail || '')).toLowerCase();
    return s.indexOf(q) !== -1;
  }

  function loadQuotesList() {
    if (state.quotesCache && !_qwLoading) { renderQuotesList(state.quotesCache); return; }
    if (_qwLoading) { _qwRender(); return; }
    var seq = ++_qwLoadSeq;
    _qwLoading = true; _qwLoadErr = false; _qwPartial = []; _qwVersions = null;
    var seen = {};
    _qwRender();
    if (state.ref && /-[A-Z]$/.test(String(state.ref))) {
      API.get('/quote-chain?ref=' + encodeURIComponent(state.ref)).then(function(d) {
        if (seq !== _qwLoadSeq) return;
        _qwVersions = (d && Array.isArray(d.revisions) ? d.revisions : []).map(function(r) {
          return { reference: r.reference, customer: r.customerName || '', customerEmail: r.customerEmail || '', total: r.total };
        });
        _qwRender();
      }).catch(function() { if (seq === _qwLoadSeq) { _qwVersions = []; _qwRender(); } });
    } else {
      _qwVersions = [];
    }
    function finish(err) {
      if (seq !== _qwLoadSeq) return;
      _qwLoading = false; _qwLoadErr = !!err;
      if (!err) state.quotesCache = _qwPartial.slice();
      _qwRender();
    }
    function nextPage(page) {
      API.get('/rep-quotes?status=all&limit=' + _QW_PAGE + '&page=' + page).then(function(data) {
        if (seq !== _qwLoadSeq) return;
        var rows = (data && data.quotes) || [];
        rows.forEach(function(q) {
          var ref = q.reference || q.ref || '';
          if (!ref || seen[ref]) return;
          seen[ref] = 1; _qwPartial.push(q);
        });
        _qwRender();
        var totalPages = (data && data.pagination && data.pagination.totalPages) || 1;
        if (page < totalPages && rows.length >= _QW_PAGE && _qwPartial.length < _QW_MAX) nextPage(page + 1);
        else finish(false);
      }).catch(function() { finish(true); });
    }
    nextPage(1);
  }

  function _qwRowHtml(q, extraClass, note) {
    var ref = q.reference || q.ref || '';
    var org = q.customerCompany || '';
    var name = q.customer || '';
    var html = '<div class="rq-ws-bar__load-item' + (extraClass || '') + '" data-ref="' + escAttr(ref) + '">';
    html += '<div class="rq-ws-bar__load-item-info">';
    if (org && name) {
      html += '<span class="rq-ws-bar__load-item-org">' + escHtml(org) + '</span>';
      html += '<span class="rq-ws-bar__load-item-name">' + escHtml(name) + '</span>';
    } else {
      html += '<span class="rq-ws-bar__load-item-org">' + escHtml(org || name || 'Unknown') + '</span>';
    }
    if (note) html += '<span class="rq-ws-bar__load-item-name">' + escHtml(note) + '</span>';
    html += '</div>';
    html += '<span class="rq-ws-bar__load-item-ref">' + escHtml(ref) + '</span>';
    html += '</div>';
    return html;
  }
  function _qwMoney(n) {
    var v = parseFloat(n);
    if (!isFinite(v) || v <= 0) return '';
    return '$' + v.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function _qwWire() {
    dom.loadResults.querySelectorAll('.rq-ws-bar__load-item').forEach(function(el) {
      el.addEventListener('click', function() {
        var ref = this.getAttribute('data-ref');
        if (ref === state.ref) { toggleLoadDropdown(false); return; }
        toggleLoadDropdown(false);
        loadQuote(ref);
      });
    });
  }

  /* One render for every moment of the load: versions, then what has arrived, then the status line. */
  function _qwRender() {
    var q = _qwSearch();
    var html = '';
    var vers = (_qwVersions || []).filter(function(v) { return _qwMatches(v, q); });
    if (_qwVersions && _qwVersions.length > 1 && vers.length) {
      html += '<div class="rq-ws-bar__load-head">Versions of this quote</div>';
      vers.forEach(function(v) {
        var isOpen = v.reference === state.ref;
        var note = [_qwMoney(v.total), isOpen ? 'open now' : ''].filter(Boolean).join(' · ');
        html += _qwRowHtml(v, isOpen ? ' rq-ws-bar__load-item--current' : '', note);
      });
      html += '<div class="rq-ws-bar__load-head">All quotes</div>';
    }
    var list = (state.quotesCache && !_qwLoading) ? state.quotesCache : _qwPartial;
    /* Ryan 2026-10-10: a version listed above is not repeated under All quotes. */
    var shownAbove = {};
    if (_qwVersions && _qwVersions.length > 1) _qwVersions.forEach(function(v) { shownAbove[v.reference] = 1; });
    var rows = list.filter(function(x) { return !shownAbove[x.reference || x.ref || ''] && _qwMatches(x, q); });
    rows.forEach(function(x) { html += _qwRowHtml(x, '', ''); });
    if (_qwLoading) {
      html += '<div class="rq-ws-bar__load-empty">' + (list.length ? 'Loading more... (' + list.length + ' so far)' : 'Loading...') + '</div>';
    } else if (_qwLoadErr) {
      html += '<div class="rq-ws-bar__load-empty">' + (list.length ? 'Could not load the rest of the quotes' : 'Failed to load quotes') + '</div>';
    } else if (!rows.length && !vers.length) {
      html += '<div class="rq-ws-bar__load-empty">No quotes found</div>';
    }
    dom.loadResults.innerHTML = html;
    _qwWire();
  }

  function renderQuotesList(quotes) {
    /* The finished list (or a caller's own list): same render. */
    if (quotes === state.quotesCache) { _qwRender(); return; }
    var html = '';
    (quotes || []).forEach(function(x) { html += _qwRowHtml(x, '', ''); });
    dom.loadResults.innerHTML = html || '<div class="rq-ws-bar__load-empty">No quotes found</div>';
    _qwWire();
  }

  function filterQuotesList(q) {
    _qwRender();
  }

  /* ── Sold Quote Lock ── */
  function lockWorkstation(statusLabel) {
    state.locked = true;
    wrap.classList.add('rq-ws--locked');
    // Status badge
    if (dom.barStatus) {
      dom.barStatus.textContent = statusLabel || 'SOLD — Read Only';
      dom.barStatus.style.display = '';
      dom.barStatus.style.background = '#c0392b';
      dom.barStatus.style.color = '#fff';
      dom.barStatus.style.padding = '2px 10px';
      dom.barStatus.style.borderRadius = '4px';
      dom.barStatus.style.fontWeight = '600';
      dom.barStatus.style.fontSize = '12px';
    }
    // Disable financial inputs (items, fees, send settings) — leave customer section editable
    var lockSections = ['.rq-ws-section--items', '.rq-ws-section--fees', '.rq-ws-freight-panel',
      '.rq-ws-install-panel', '.rq-ws-send'];
    lockSections.forEach(function(sel) {
      var section = wrap.querySelector(sel);
      if (!section) return;
      section.querySelectorAll('input, select, textarea').forEach(function(el) { el.disabled = true; });
      section.querySelectorAll('.rq-ws-custom-select').forEach(function(cs) {
        cs.style.pointerEvents = 'none'; cs.style.opacity = '0.6';
      });
    });
    // Disable send button only (keep save + PDF download usable)
    var sendBtn = wrap.querySelector('.rq-ws-send__send');
    if (sendBtn) sendBtn.disabled = true;
    // Hide add/search controls and item delete/drag
    var hideSelectors = ['.rq-ws-search-bar', '.rq-ws-custom-add-wrap', '.rq-ws-bulk-wrap',
      '.rq-ws-fees__add-btn', '.rq-ws-item-delete', '.rq-ws-table__drag-handle',
      '.rq-ws-subdesc-drag'];
    hideSelectors.forEach(function(sel) {
      wrap.querySelectorAll(sel).forEach(function(el) { el.style.display = 'none'; });
    });
  }

  /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-21) — replacement chrome. The class does
     the work (the items table re-renders constantly, so disabling individual inputs here
     would not survive the next render — see the CSS in rep-quote-workstation.liquid, plus
     the field guard in workstation-table.js). */
  /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-22) — "↩ Replacement for JW-1129-F" in the
     top bar. The bar label is built from customer + ref ("Aaron LoCascio - RPL-1001-A"),
     which says nothing about the order being replaced, and the only other mention was the
     damaged-items picker's sub-line — a panel with a Hide button. The parent ref is the
     first thing an admin needs here, so it gets a permanent home.
     ⛔ target="_blank": the picker's quantities are unsaved DOM state, so a same-tab jump
     to the parent would throw them away silently. Own element rather than folding into
     dom.barStatus, which setStatusBadge rewrites wholesale. */
  function renderReplacementFor() {
    var el = wrap.querySelector('.rq-ws-bar__replacement-for');
    if (!el) return;
    var parent = state.isReplacement ? (state.replacementParentRef || '') : '';
    if (!parent) { el.style.display = 'none'; el.innerHTML = ''; return; }
    el.innerHTML = '↩ Replacement for <a href="' +
      escAttr(window.location.pathname + '?ref=' + encodeURIComponent(parent)) +
      '" target="_blank" rel="noopener" title="Open the original order in a new tab">' +
      escHtml(parent) + '</a>';
    el.style.display = '';
  }

  function applyReplacementMode() {
    wrap.classList.add('rq-ws--replacement');
    renderReplacementFor();
    /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-22) — CFA Attribution is always None on a
       replacement. Nobody is credited for a $0 re-ship of goods the customer already paid
       for — and it is not cosmetic: a save carrying a CFA code MINTS a
       `cfa-attribution:{email}` record at 10% when the customer has none, binding them to
       that CFA for every future deal. The server forces 'none' regardless of what is
       posted (handleSaveWorkstation); this keeps the field honest on screen, and the two
       auto-fill blurs in workstation-customer.js bail on a replacement so nothing
       overwrites it behind the rep's back. */
    state.cfaAttribution = 'none';
    var cfaSelR = wrap.querySelector('select[data-field="cfaAttribution"]');
    if (cfaSelR) {
      /* The option list arrives async from /cfa-list; that loader re-applies
         state.cfaAttribution when it lands, so this is correct in either order. */
      cfaSelR.value = 'none';
      syncCustomSelect(cfaSelR);
    }
    if (dom.barStatus) {
      dom.barStatus.textContent = 'REPLACEMENT — No Charge';
      dom.barStatus.style.display = '';
      dom.barStatus.style.background = '#f59e0b';
      dom.barStatus.style.color = '#451a03';
      dom.barStatus.style.padding = '2px 10px';
      dom.barStatus.style.borderRadius = '4px';
      dom.barStatus.style.fontWeight = '700';
      dom.barStatus.style.fontSize = '12px';
    }
    /* ⛔ Send is disabled outright: a $0 "quote" must never reach the customer. They are
       not being asked to buy anything — they are owed goods. Download PDF stays, because
       an internal paper trail of what we re-shipped is genuinely useful. */
    var sendBtn = wrap.querySelector('.rq-ws-send__send');
    if (sendBtn) { sendBtn.disabled = true; sendBtn.title = 'A replacement order is never sent to the customer — it is $0 and they owe nothing.'; }
    /* The damaged-items picker (workstation-replacement.js) — the admin's first job. */
    if (Q.renderReplacementPicker) Q.renderReplacementPicker();
  }

  function unlockWorkstation() {
    state.locked = false;
    wrap.classList.remove('rq-ws--locked');
    if (dom.barStatus) { dom.barStatus.style.display = 'none'; dom.barStatus.style.background = ''; }
    wrap.querySelectorAll('input:disabled, select:disabled, textarea:disabled').forEach(function(el) { el.disabled = false; });
    wrap.querySelectorAll('button:disabled').forEach(function(btn) { btn.disabled = false; });
    wrap.querySelectorAll('.rq-ws-custom-select').forEach(function(cs) { cs.style.pointerEvents = ''; cs.style.opacity = ''; });
  }

  /* ── Lead Submission Modal ── */
  // Stash the active lead context here so the click handler doesn't have to
  // re-fetch — populated when loadQuote/setNew is called.
  var currentLeadContext = null;
  var leadBtn = wrap.querySelector('.rq-ws-bar__btn--lead-submission');
  var leadModal = wrap.querySelector('#rq-ws-lead-modal');
  var leadModalBody = leadModal && leadModal.querySelector('.rq-ws-lead-modal__body');

  /* CUSTOM_MARKETINGOPS_BY_CLAUDE (2026-07-24, DNI P0) — read-only ad-verified badge, now the
     WHOLE of the "Ad Attribution" field (the Lead Source select it used to sit under was retired
     in the decoupling piece 3). ac = the /quote-details `adChannel` bundle { channel, dialedNumber }
     (derived from the callattr tracking-number call / UTM journey — a hard signal the rep can't
     fabricate; suppressed server-side on a PAID Shared Deal referral). Display-only: the rep never
     sets the ad channel, so this never becomes a field. NO empty state — the whole field hides when
     there's no badge, because this bundle only sees the callattr call while Marketing Ops also
     resolves journey / landing-site / Phase-G, so an absent badge is not evidence of "no ad". */
  var adVerifiedEl = wrap.querySelector('[data-ad-verified]');
  var adAttrFieldEl = wrap.querySelector('[data-ad-attr-field]');
  var AD_CH_LABELS = { google: 'Google', meta: 'Meta', bing: 'Microsoft', openai: 'OpenAI', 'paid-other': 'Paid Ad' };
  function applyAdChannel(ac) {
    if (!adVerifiedEl) return;
    if (ac && ac.channel) {
      var label = AD_CH_LABELS[ac.channel] || (ac.channel.charAt(0).toUpperCase() + ac.channel.slice(1));
      var textEl = adVerifiedEl.querySelector('.rq-ws-ad-verified__text');
      if (textEl) textEl.textContent = 'Ad-verified: ' + label + (ac.dialedNumber ? ' · called ' + ac.dialedNumber : '');
      adVerifiedEl.style.display = 'inline-flex';
      if (adAttrFieldEl) adAttrFieldEl.style.display = '';
    } else {
      adVerifiedEl.style.display = 'none';
      if (adAttrFieldEl) adAttrFieldEl.style.display = 'none';
    }
  }

  function applyLeadContext(ctx) {
    currentLeadContext = ctx && (ctx.message || (ctx.responses && Object.keys(ctx.responses).length) || (ctx.attachments && ctx.attachments.length) || ctx.formName || ctx.source) ? ctx : null;
    if (!leadBtn) return;
    leadBtn.style.display = currentLeadContext ? '' : 'none';
  }

  function humanize(key) {
    if (!key) return key;
    return String(key).replace(/[-_]+/g, ' ').replace(/\s+/g, ' ').trim()
      .split(' ').map(function(w) { return w.length === 0 ? w : (w[0].toUpperCase() + w.slice(1)); })
      .join(' ');
  }

  function renderLeadModalBody() {
    if (!leadModalBody) return;
    var ctx = currentLeadContext;
    if (!ctx) { leadModalBody.innerHTML = ''; return; }

    var html = '';
    var groupLabel = (ctx.sourceGroup === 'web-form') ? 'Web Form'
      : (ctx.sourceGroup === 'sample-request') ? 'Sample Request'
      : (ctx.sourceGroup === 'rfq') ? 'Add to Quote'
      : (ctx.sourceGroup === 'manual') ? 'Phone' : (ctx.sourceGroup || 'Lead');
    var icon = (ctx.sourceGroup === 'web-form') ? '📝' : (ctx.sourceGroup === 'sample-request') ? '🧪' : (ctx.sourceGroup === 'rfq') ? '🛒' : (ctx.sourceGroup === 'manual') ? '📞' : '📩';

    var headingText = icon + ' ' + escHtml(groupLabel) + (ctx.formName ? ' — ' + escHtml(ctx.formName) : '');
    var headingHtml = (ctx.sourceUrl && ctx.sourceGroup !== 'manual')
      ? '<a href="' + escAttr(ctx.sourceUrl) + '" target="_blank" rel="noopener" style="color:inherit;text-decoration:underline;">' + headingText + '</a>'
      : headingText;
    html += '<div class="rq-ws-lead-modal__heading">' + headingHtml + '</div>';

    if (ctx.submittedAt) {
      var d;
      try { d = new Date(ctx.submittedAt).toLocaleString('en-US', { dateStyle: 'medium', timeStyle: 'short' }); } catch (e) { d = ctx.submittedAt; }
      html += '<div class="rq-ws-lead-modal__sub">Submitted ' + escHtml(d) + (ctx.sourceLeadRef ? ' · Lead ref ' + escHtml(ctx.sourceLeadRef) : '') + '</div>';
    }

    if (ctx.message && String(ctx.message).trim()) {
      html += '<div class="rq-ws-lead-modal__section-label">Customer Message</div>';
      // Allow the worker-sanitized HTML through (it only permits b/i/u/strong/em/br)
      html += '<div class="rq-ws-lead-modal__message">' + ctx.message + '</div>';
    }

    if (ctx.responses && typeof ctx.responses === 'object') {
      var keys = Object.keys(ctx.responses).filter(function(k) {
        var v = ctx.responses[k];
        return v !== null && v !== undefined && String(v).trim() !== '';
      });
      if (keys.length > 0) {
        html += '<div class="rq-ws-lead-modal__section-label">Form Responses</div>';
        html += '<div class="rq-ws-lead-modal__responses">';
        keys.forEach(function(k) {
          html += '<div class="rq-ws-lead-modal__resp-key">' + escHtml(humanize(k)) + '</div>' +
                  '<div class="rq-ws-lead-modal__resp-val">' + escHtml(String(ctx.responses[k])) + '</div>';
        });
        html += '</div>';
      }
    }

    if (Array.isArray(ctx.attachments) && ctx.attachments.length > 0) {
      html += '<div class="rq-ws-lead-modal__section-label">Attachments</div>';
      html += '<ul class="rq-ws-lead-modal__attachments">';
      ctx.attachments.forEach(function(a, i) {
        var url = typeof a === 'string' ? a : (a && a.url) || '';
        var name = (typeof a === 'object' && a && a.name) ? a.name : ('Attachment ' + (i + 1));
        if (url) html += '<li><a href="' + escAttr(url) + '" target="_blank" rel="noopener">' + escHtml(name) + '</a></li>';
      });
      html += '</ul>';
    }

    leadModalBody.innerHTML = html;
  }

  function openLeadModal() {
    if (!leadModal || !currentLeadContext) return;
    renderLeadModalBody();
    leadModal.style.display = '';
    document.addEventListener('keydown', leadModalKeyHandler);
  }
  function closeLeadModal() {
    if (!leadModal) return;
    leadModal.style.display = 'none';
    document.removeEventListener('keydown', leadModalKeyHandler);
  }
  function leadModalKeyHandler(e) { if (e.key === 'Escape') closeLeadModal(); }

  if (leadBtn) leadBtn.addEventListener('click', openLeadModal);
  if (leadModal) {
    var lmBackdrop = leadModal.querySelector('.rq-ws-lead-modal__backdrop');
    var lmClose = leadModal.querySelector('.rq-ws-lead-modal__close');
    if (lmBackdrop) lmBackdrop.addEventListener('click', closeLeadModal);
    if (lmClose) lmClose.addEventListener('click', closeLeadModal);
  }

  // Expose for cross-module use (workstation-customer.js calls this when the
  // rep clicks "+ New Quote" so the button hides between quotes).
  Q.setLeadContext = applyLeadContext;

  /* ── Load Quote ── */
  function loadQuote(ref) {
    dom.barRef.textContent = ref;
    dom.barStatus.style.display = 'none';
    /* CUSTOM_RFQPORTAL_BY_CLAUDE — Hide the completed-draft banner at the
       start of every load. /quote-details response below sets it back to
       visible when the Shopify draft status comes back COMPLETED. Clean
       reset each load so jumping between a paid quote and an unpaid one
       doesn't leak the banner. */
    var _frozenBanner = wrap.querySelector('.rq-ws-frozen-banner');
    if (_frozenBanner) _frozenBanner.style.display = 'none';
    /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
    state.ref = ref;
    state.mode = 'edit';
    state.freightHold = null; // CUSTOM_FREIGHTPROMISE_BY_CLAUDE - set from /quote-details below
    state.paidThroughShopify = false; // CUSTOM_QWALERTS_BY_CLAUDE (Pass 2)
    if (Q.clearQuoteAlerts) Q.clearQuoteAlerts(); else if (Q.renderAlerts) Q.renderAlerts();

    // Lead handoff cache: when the dashboard redirects here after a
    // /create-quote-from-lead conversion, it stashes customer + leadContext
    // in sessionStorage. KV propagation between POPs can lag the redirect,
    // and Shopify's tag-search index can lag the draft order create, so
    // /quote-details may briefly return blank or 404 on first load. Read
    // the stash NOW and populate the form synchronously so the rep sees
    // Sold To filled instantly — then merge in /quote-details when it
    // arrives.
    var leadHandoff = null;
    try {
      var stashed = sessionStorage.getItem('bsfs_lead_handoff:' + ref);
      if (stashed) {
        var parsed = JSON.parse(stashed);
        if (parsed && parsed.stashedAt && (Date.now() - parsed.stashedAt < 300000)) {
          leadHandoff = parsed;
        }
        sessionStorage.removeItem('bsfs_lead_handoff:' + ref);
      }
    } catch (e) { /* JSON parse / storage failures are non-fatal */ }

    // Instant populate — fires before the network round-trip so the form
    // is filled the moment the workstation paints, not when the API responds.
    if (leadHandoff && leadHandoff.customer) {
      Q.populateCustomer({ customer: leadHandoff.customer });
    }
    if (leadHandoff && leadHandoff.leadContext) {
      applyLeadContext(leadHandoff.leadContext);
    }
    // Lead-derived quotes default to Inbound + None on first open. Without
    // this synchronous default, the dropdowns render blank ("-- Select --")
    // until KV propagates and the rep refreshes — confusing UX.
    if (leadHandoff) {
      state.leadSource = 'inbound';
      state.cfaAttribution = 'none';
      var lsSel0 = wrap.querySelector('select[data-field="leadSource"]');
      if (lsSel0) { lsSel0.value = 'inbound'; syncCustomSelect(lsSel0); }
      var cfaSel0 = wrap.querySelector('select[data-field="cfaAttribution"]');
      if (cfaSel0) { cfaSel0.value = 'none'; syncCustomSelect(cfaSel0); }
      /* CUSTOM_MARKETINGOPS_BY_CLAUDE (2026-07-24, DNI decoupling piece 3) — the lead's intake
         source no longer needs copying into a rep-facing dropdown: it already lives on the
         quote's leadContext (written server-side at promotion), which is what Marketing Ops
         reads. Nothing to classify here. */
    }

    // Server-side fallback: pass ?leadRef=… so the worker can read the
    // (long-since propagated) lead:{ref} record when workstation_meta
    // hasn't propagated yet. With the new lead-ref-reuse design, ref IS
    // the lead ref — pass it through so the worker fallback can fire.
    var detailsUrl = '/quote-details?ref=' + encodeURIComponent(ref) + '&leadRef=' + encodeURIComponent(ref);

    /* CUSTOM_ROOMDESIGNER_BY_CLAUDE — return promise so RD handoff (revision/append modes) can await load completion */
    /* CUSTOM_ROOMDESIGNER_BY_CLAUDE (Ryan 2026-07-01) — First-open blank Sold To
       fix. When this load follows a fresh /create-quote-from-lead (leadHandoff
       stash present), a 404 here almost always means Shopify's tag-search index
       hasn't caught up with the just-created draft — not that the quote is
       missing. Retry with backoff before surrendering to the pending/error
       fallbacks. Gated on leadHandoff so genuinely-missing refs (e.g. PENDING
       deals, which rely on a fast 404 → /pending-quote fallback) keep failing
       fast. */
    function getDetails(attempt) {
      return API.get(detailsUrl).catch(function(err) {
        if (leadHandoff && err && err.status === 404 && attempt < 3) {
          return new Promise(function(res) { setTimeout(res, 1200 * (attempt + 1)); })
            .then(function() { return getDetails(attempt + 1); });
        }
        throw err;
      });
    }
    return getDetails(0).then(function(data) {
      if (!data || !data.quote) {
        dom.barStatus.style.display = 'none';
        // Even if /quote-details 404s (Shopify tag-search index lag right
        // after /create-quote-from-lead), the form is already filled from
        // the handoff. Make sure state.draftOrderId is set so the rep can
        // still save without minting a duplicate draft order.
        if (leadHandoff && leadHandoff.draftOrderId) {
          state.draftOrderId = leadHandoff.draftOrderId;
        }
        return;
      }

      state.mode = 'edit';
      state.ref = ref;
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-22) — phantom-dirty guard. Load-time
         renders/recalcs (admin freight + install panels; recalcTotals ALWAYS flags
         dirty; programmatic ship/bill toggle dispatches) marked the quote "dirty" with
         zero edits — incl. via setTimeout-based freight renders that fire AFTER any
         end-of-load reset — tripping the "unsaved changes" exit prompt. Route
         state.dirty through a setter that IGNORES dirty=true while suppressed.
         Suppression stays on through load and clears on the rep's FIRST real
         interaction (armed at the end of load; isTrusted events only). */
      if (!state._dirtyGuarded) {
        state._dirtyGuarded = true;
        var _dirtyVal = !!state.dirty;
        Object.defineProperty(state, 'dirty', {
          configurable: true,
          get: function () { return _dirtyVal; },
          set: function (v) { if (v === true && state.suppressDirty) return; _dirtyVal = v; }
        });
      }
      state.suppressDirty = true;
      state.dirty = false;
      state.draftOrderId = (data.quote && data.quote.id) || '';

      var q = data.quote;
      /* CUSTOM_FREIGHTPROMISE_BY_CLAUDE (Ryan 2026-10-23) - the banner's 30-day freight facts; drawn once the rest of this
         load has set state.freight (same tick, so the alert reads the loaded status). */
      state.freightHold = data.freightHold || null;
      if (Q.renderAlerts) setTimeout(Q.renderAlerts, 0);

      /* CUSTOM_RFQPORTAL_BY_CLAUDE — Completed-draft detection. When the
         Shopify draft order's raw status is COMPLETED, the customer has
         paid via the hosted invoice and Shopify has frozen the draft's
         line items. SKU/title/qty edits in the workstation save to
         workstation_meta KV (and flow through to PO generation +
         dashboard Order Contents via the KV-first read paths), but
         draftOrderUpdate can't change the underlying Shopify Admin order
         anymore. Banner makes that divergence explicit so reps don't
         expect Shopify Admin to reflect their corrections. */
      /* CUSTOM_QWALERTS_BY_CLAUDE (Ryan 2026-10-23, Pass 2) - shown as a row in the alerts banner now; the old box stays hidden. */
      state.paidThroughShopify = !!(q && q.draftStatus === 'COMPLETED');
      if (_frozenBanner) _frozenBanner.style.display = Q.renderAlerts ? 'none' : (state.paidThroughShopify ? '' : 'none');
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */

      // Lead Submission button — shown when this quote stemmed from a lead.
      // /quote-details resolves leadContext from workstation_meta.leadContext
      // or falls back to lead:{ref}. Fall back further to the handoff cache
      // if KV hasn't propagated yet.
      applyLeadContext(data.leadContext || (leadHandoff && leadHandoff.leadContext) || null);

      // CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-07-09) — repeat-buyer pill. Server
      // /quote-details returns a repeatBuyer bundle (auto-detect of a prior SOLD deal by
      // email/phone + the saved manual override). Render it. Comp-neutral.
      if (typeof Q.applyRepeatBuyer === 'function') Q.applyRepeatBuyer(data.repeatBuyer || null);

      // CUSTOM_MARKETINGOPS_BY_CLAUDE (2026-07-24, DNI P0) — read-only ad-verified badge.
      applyAdChannel(data.adChannel || null);

      // Update bar
      if (dom.btnNew) dom.btnNew.classList.remove('rq-ws-bar__btn--active');
      dom.btnLoad.classList.add('rq-ws-bar__btn--active');
      dom.barRef.textContent = ref;
      Q.setStatusBadge(''); // hide badge on load

      // Customer info — prefer KV metadata (has correct field names), fall back to Shopify quote data.
      // Lead-handoff fallback patches in any blank top-level fields when the
      // KV write from /create-quote-from-lead hasn't propagated yet.
      var metaCustomer = (data.workstationMeta || {}).customer || {};
      if (leadHandoff && leadHandoff.customer) {
        var hc = leadHandoff.customer;
        Object.keys(hc).forEach(function(k) {
          if (!metaCustomer[k] && hc[k]) metaCustomer[k] = hc[k];
        });
      }
      if (metaCustomer.name || metaCustomer.email) {
        // KV has the customer data with our field names (street, city, state, zip)
        Q.populateCustomer({ customer: metaCustomer });
      } else {
        // Fall back to Shopify data — map shippingAddress fields to our field names
        var mapped = Object.assign({}, q.customer || {});
        if (q.shippingAddress) {
          mapped.street = q.shippingAddress.address1 || '';
          mapped.street2 = q.shippingAddress.address2 || '';
          mapped.city = q.shippingAddress.city || '';
          mapped.state = q.shippingAddress.provinceCode || '';
          mapped.zip = q.shippingAddress.zip || '';
          if (!mapped.company) mapped.company = q.shippingAddress.company || '';
        }
        Q.populateCustomer({ customer: mapped });
      }
      var notesField = wrap.querySelector('[data-field="notes"]');
      if (notesField) {
        var repNotes = metaCustomer.notes || '';
        notesField.value = (repNotes && repNotes !== '—') ? repNotes : '';
      }

      // Customer section already collapsed by ?ref= pre-collapse (no flash on load)

      // Line items
      state.items = [];
      var meta = data.workstationMeta || {};
      var metaItems = (meta && meta.items) || {};

      // Filter out fee line items (Shipping & Freight, Installation, custom fees) — they're handled by the fees system
      var feeItemFilter = function(title) {
        var t = (title || '').toLowerCase();
        return t.startsWith('shipping & freight') || t.startsWith('installation') || t.indexOf('card processing fee') !== -1 || t.startsWith('tax') || t.startsWith('by completing payment');
      };
      var customFeeTitles = {};
      if (meta.fees && meta.fees.length) {
        meta.fees.forEach(function(f) { if (f.title) customFeeTitles[f.title.toLowerCase()] = true; });
      }

      /* CUSTOM_RFQPORTAL_BY_CLAUDE (2026-08-22) — ⛔ THE REPLACEMENT PLACEHOLDER IS NOT AN ITEM.
         A replacement order is spawned with one $0 "items pending selection" line, because
         Shopify will not create a draft order with an empty lineItems array and the admin has
         not picked the damaged items yet. Hydrating it here made it a REAL item: it rendered in
         Order Contents under the "OTHER" vendor group, and the next save wrote it into wm.items
         and pushed it straight back onto the draft, where it stayed forever. Dropped on load, so
         the first save clears it — which is what the create-time comment always claimed happened.
         ⛔ The string must match lib/replacement-order.js REPLACEMENT_PLACEHOLDER_TITLE byte for
         byte (em dash included); theme JS cannot import from the worker. This is the HINT — the
         guarantee is handleSaveWorkstation, which strips it again if a stale tab posts it, and
         re-seeds it when a save would otherwise leave the draft with no lines at all. */
      var REPLACEMENT_PLACEHOLDER_TITLE = 'Replacement — items pending selection';

      var _occ = {};   // CUSTOM_ECORE2027_BY_CLAUDE — nth line of the same variant; save keys the 2nd+ as `<variantId>#n`
      if (q.lineItems && q.lineItems.length) {
        q.lineItems.filter(function(li) {
          return !feeItemFilter(li.title) && !customFeeTitles[(li.title || '').toLowerCase()]
            && (li.title || '').trim() !== REPLACEMENT_PLACEHOLDER_TITLE;
        }).forEach(function(li) {
          var variantId = li.variantId || li.variant_id || null;
          // Match KV metadata: try variantId in BOTH formats (Shopify returns
          // the full gid://shopify/ProductVariant/12345 while save stores by
          // either format depending on the entry path), then title, then scan
          // by handle/vendor/sku.
          var numericVariantId = variantId ? String(variantId).replace('gid://shopify/ProductVariant/', '') : null;
          var _n = variantId ? (_occ[variantId] = (_occ[variantId] || 0) + 1) : 1;
          var m = {};
          if (variantId && _n > 1 && (metaItems[variantId + '#' + _n] || metaItems[numericVariantId + '#' + _n])) {
            m = metaItems[variantId + '#' + _n] || metaItems[numericVariantId + '#' + _n];
          } else if (variantId && metaItems[variantId]) {
            m = metaItems[variantId];
          } else if (numericVariantId && metaItems[numericVariantId]) {
            m = metaItems[numericVariantId];
          } else if (li.title && metaItems[li.title]) {
            m = metaItems[li.title];
          } else {
            // Scan all keys for a match by vendor+sku, handle, or title containment
            var liVendor = li.vendor || '';
            var matched = false;
            Object.keys(metaItems).forEach(function(k) {
              if (matched) return;
              var mk = metaItems[k];
              if (mk.vendor && mk.sku && li.sku && mk.sku === li.sku && mk.vendor === liVendor) { m = mk; matched = true; return; }
              if (mk.productHandle && li.handle && mk.productHandle === li.handle && mk.vendor === liVendor) { m = mk; matched = true; return; }
              if (mk.title && li.title && mk.vendor === liVendor && li.title.indexOf(mk.title) !== -1 && mk.title.length > 3) { m = mk; matched = true; return; }
            });
          }

          // Spacer rows: clear the placeholder title back to blank
          var isSpacer = li.isSpacer || (!variantId && (li.title === '—' || li.title === '—') && !li.sku);

          // Recover SKU: prefer KV metadata, then Shopify variant, then extract from title
          var loadedTitle = isSpacer ? '' : (li.title || li.name || '');
          var loadedSku = isSpacer ? '' : (m.sku || li.sku || '');
          if (!loadedSku && loadedTitle) {
            var em = extractModel(loadedTitle, '');
            loadedSku = em.sku;
            if (loadedSku) loadedTitle = em.title;
          }
          /* CUSTOM_QWVENDORSTRIP_BY_CLAUDE (Ryan 2026-10-10) — the same name a catalogue line gets when it is
             ADDED (Q.quoteTitle: the quote-name override, then the supplier name dropped from the front). Shopify
             keeps the full product title on a variant line, so without this "E-Grip III Adhesive" came back
             as "ECORE E-Grip III Adhesive" every time the quote was reopened. Catalogue lines only: a custom
             line's title is what the rep typed. Tried with the supplier as stored and its short form
             ("ECORE Athletic" -> "ECORE"). */
          if (!isSpacer && !li.custom && variantId && loadedTitle && Q.quoteTitle) {
            var _ldVendor = m.vendor || li.vendor || '';
            var _ldProduct = { handle: m.productHandle || li.handle || '', title: loadedTitle, vendor: _ldVendor };
            var _ldName = Q.quoteTitle(_ldProduct);
            if (_ldName === loadedTitle && Q.normalizeVendor && Q.normalizeVendor(_ldVendor) !== _ldVendor) {
              _ldProduct.vendor = Q.normalizeVendor(_ldVendor);
              _ldName = Q.quoteTitle(_ldProduct);
            }
            if (_ldName) loadedTitle = _ldName;
          }

          var item = {
            id: genId(),
            type: (li.custom || isSpacer) ? 'custom' : 'product',
            variantId: variantId,
            vendor: isSpacer ? '' : (m.vendor || li.vendor || ''),
            title: loadedTitle,
            sku: loadedSku,
            quantity: li.quantity || 1,
            msrp: isSpacer ? 0 : (parseFloat(m.msrp) === -1 ? -1 : (parseFloat(li.compareAtPrice) || parseFloat(m.msrp) || 0)),
            cost: isSpacer ? 0 : (parseFloat(m.cost) || 0),
            points: isSpacer ? 0 : (parseFloat(m.points) || 0),
            directPrice: isSpacer ? 0 : (parseFloat(m.directPrice) || parseFloat(li.price || li.originalUnitPrice) || 0),
            mapPrice: isSpacer ? 0 : (parseFloat(m.mapPrice) || 0),
            isFree: m.isFree || false,
            subDescriptions: m.subDescriptions || [],
            internalNote: m.internalNote || '',
            seriesId: m.seriesId || null,
            seriesWeight: m.seriesWeight != null ? m.seriesWeight : null,
            seriesBaseTitle: m.seriesBaseTitle || null,
            seriesBaseSku: m.seriesBaseSku || null,
            // CUSTOM_WEIGHTDESIGNER_BY_CLAUDE (Ryan 2026-09-01) — the third copy of this list;
            // without it the flag survives the save and dies on reopen instead.
            seriesIsPlates: !!m.seriesIsPlates,
            configured: m.configured !== false,
            productHandle: m.productHandle || li.handle || null,
            pendingOptions: m.pendingOptions || null,
            customOptions: m.customOptions || null,
            /* CUSTOM_RFQPORTAL_BY_CLAUDE — Indent flag carries over so the
               drag-right gesture's result survives reloads. */
            indented: !!m.indented,
            /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
            /* CUSTOM_RFQPORTAL_BY_CLAUDE — Unit-toggle mode (per-piece ↔ per-sq-ft)
               survives reload. Saved values already reflect the active mode. */
            unitMode: m.unitMode || 'piece',
            /* CUSTOM_RFQPORTAL_BY_CLAUDE — Per-item external product link (custom
               manual-entry items) survives reload so the chip re-renders. */
            externalLink: m.externalLink || ''
          };

          // Recalculate directPrice from cost + points (ensures consistency after load)
          if (item.cost > 0 && item.points > 0) {
            item.directPrice = calculateDirect(item.cost, item.points);
          } else if (item.cost > 0 && item.points === 0 && item.directPrice > 0) {
            item.points = reversePoints(item.cost, item.directPrice);
          }

          state.items.push(item);
        });
      }

      // Fees
      if (meta.fees && meta.fees.length) {
        state.customFees = meta.fees.filter(function(f) {
          return f.title !== 'Shipping & Freight' && f.title !== 'Installation';
        });
        Q.renderCustomFees();
      }

      // Standard fees from saved rawFees (preserves FREE/None/Pending status)
      // Fall back to quote data for older saves without rawFees
      var rawFees = meta.rawFees || [];
      var shipRaw = rawFees.find(function(f) { return f.title === 'Shipping & Freight'; });
      var instRaw = rawFees.find(function(f) { return f.title === 'Installation'; });
      if (shipRaw) {
        state.fees[0].status = shipRaw.status || 'pending';
        state.fees[0].amount = parseFloat(shipRaw.amount) || 0;
        var shipInput = wrap.querySelector('.rq-ws-fees__input[data-fee="shipping"]');
        var shipSel = wrap.querySelector('.rq-ws-fees__status[data-fee="shipping"]');
        if (shipSel) shipSel.value = state.fees[0].status;
        if (shipInput) {
          shipInput.value = state.fees[0].status === 'value' ? state.fees[0].amount.toFixed(2) : '';
          shipInput.style.display = state.fees[0].status === 'value' ? '' : 'none';
        }
      } else if (q.shippingAmount != null) {
        state.fees[0].amount = parseFloat(q.shippingAmount) || 0;
        state.fees[0].status = 'value';
        var shipInput2 = wrap.querySelector('.rq-ws-fees__input[data-fee="shipping"]');
        var shipSel2 = wrap.querySelector('.rq-ws-fees__status[data-fee="shipping"]');
        if (shipInput2) { shipInput2.value = state.fees[0].amount.toFixed(2); shipInput2.style.display = ''; }
        if (shipSel2) shipSel2.value = 'value';
      }
      if (instRaw) {
        state.fees[1].status = instRaw.status || 'pending';
        state.fees[1].amount = parseFloat(instRaw.amount) || 0;
        var instInput = wrap.querySelector('.rq-ws-fees__input[data-fee="installation"]');
        var instSel = wrap.querySelector('.rq-ws-fees__status[data-fee="installation"]');
        if (instSel) instSel.value = state.fees[1].status;
        if (instInput) {
          instInput.value = state.fees[1].status === 'value' ? state.fees[1].amount.toFixed(2) : '';
          instInput.style.display = state.fees[1].status === 'value' ? '' : 'none';
        }
      } else if (q.installationAmount != null) {
        state.fees[1].amount = parseFloat(q.installationAmount) || 0;
        state.fees[1].status = 'value';
        var instInput2 = wrap.querySelector('.rq-ws-fees__input[data-fee="installation"]');
        var instSel2 = wrap.querySelector('.rq-ws-fees__status[data-fee="installation"]');
        if (instInput2) { instInput2.value = state.fees[1].amount.toFixed(2); instInput2.style.display = ''; }
        if (instSel2) instSel2.value = 'value';
      }

      state.offlineTax = meta.offlineTax || null; // CUSTOM_OFFLINETAXROW_BY_CLAUDE - Shopify's tax from the last save (workstation-totals.js)
      state.taxPlan = meta.taxPlan || null; // CUSTOM_AUTOTAX_BY_CLAUDE - why Auto charged nothing, e.g. no permit in that state
      // Tax from saved data
      if (meta.tax) {
        state.tax.mode = meta.tax.mode || 'pending';
        state.tax.rate = parseFloat(meta.tax.rate) || 0;
        state.tax.amount = parseFloat(meta.tax.amount) || 0;
        state.tax.includeFreight = !!meta.tax.includeFreight;
        state.tax.includeInstallation = !!meta.tax.includeInstallation;
        var taxSel = wrap.querySelector('.rq-ws-fees__tax-mode');
        var taxRate = wrap.querySelector('.rq-ws-fees__tax-rate');
        if (taxSel) { taxSel.value = state.tax.mode; syncCustomSelect(taxSel); }
        /* CUSTOM_AUTOTAX_BY_CLAUDE (Ryan 2026-10-30) - the rate box is read only and painted in one place (workstation-fees.js). */
        if (Q.updateTaxUI) Q.updateTaxUI();
        else if (taxRate) taxRate.style.display = 'none';
        wrap.querySelectorAll('.rq-ws-fees__tax-check-input').forEach(function(cb) {
          var key = cb.getAttribute('data-tax-include');
          if (key === 'freight') cb.checked = state.tax.includeFreight;
          if (key === 'installation') cb.checked = state.tax.includeInstallation;
        });
      }

      // Card fee — prefer KV metadata, fall back to quote data
      var cardFeeData = meta.cardFee || q.cardFee;
      if (cardFeeData) {
        state.cardFee.status = cardFeeData.status || 'pending';
        state.cardFee.amount = parseFloat(cardFeeData.amount) || 0;
        var cfSel = wrap.querySelector('.rq-ws-fees__card-fee-mode');
        var cfAmt = wrap.querySelector('.rq-ws-fees__card-fee-amount');
        if (cfSel) cfSel.value = state.cardFee.status;
        if (cfAmt) {
          cfAmt.style.display = state.cardFee.status === 'yes' ? '' : 'none';
          if (state.cardFee.status === 'yes') cfAmt.value = fmt(state.cardFee.amount);
        }
      }

      // Freight & installation from KV metadata
      if (meta.freight) {
        state.freight = Object.assign({}, state.freight, meta.freight);
        // Ensure arrays exist
        if (!Array.isArray(state.freight.vendors)) state.freight.vendors = [];
        if (!Array.isArray(state.freight.history)) state.freight.history = [];
        if (!Array.isArray(state.freight.itemsSnapshot)) state.freight.itemsSnapshot = [];
        /* CUSTOM_RFQPORTAL_BY_CLAUDE — Heal legacy quotes saved before
           freightInsurance was a delivery flag. Object.assign above
           replaced our default deliveryConditions object wholesale, so
           legacy meta.freight.deliveryConditions (which lacks the field)
           leaves freightInsurance undefined. Default to true so the PDF's
           insurance sub-line still appears on those quotes — matches the
           UI pre-check default. */
        if (state.freight.deliveryConditions && state.freight.deliveryConditions.freightInsurance === undefined) {
          state.freight.deliveryConditions.freightInsurance = true;
        }
        /* CUSTOM_RFQPORTAL_BY_CLAUDE — Same heal for defaultDelivery (controls the
           standard Curbside/Driveway delivery sub-line). Legacy quotes lack the
           field; default to true so the line keeps printing + the checkbox paints
           checked, matching prior behavior and the new-quote default. */
        if (state.freight.deliveryConditions && state.freight.deliveryConditions.defaultDelivery === undefined) {
          state.freight.deliveryConditions.defaultDelivery = true;
        }
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
        /* CUSTOM_RFQPORTAL_BY_CLAUDE — Auto-promote pending→value ONLY for
           legacy saves with no rawFees record. When shipRaw is present, the
           save explicitly recorded the fee's status (incl. an intentional
           'pending' the admin set for multi-vendor scenarios where one
           vendor's freight is in but others aren't yet). Overriding that
           on load surfaced the partial $ to the customer-facing quote
           against admin intent. */
        if (!shipRaw && state.freight.totalQuoted > 0 && state.fees[0].amount === 0 && state.fees[0].status === 'pending') {
          state.fees[0].amount = state.freight.totalQuoted;
          state.fees[0].status = 'value';
          var shipInput2 = wrap.querySelector('.rq-ws-fees__input[data-fee="shipping"]');
          var shipSel2 = wrap.querySelector('.rq-ws-fees__status[data-fee="shipping"]');
          if (shipInput2) { shipInput2.value = state.fees[0].amount.toFixed(2); shipInput2.style.display = ''; }
          if (shipSel2) shipSel2.value = 'value';
        }
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      }
      if (meta.installation) {
        state.installation = Object.assign({}, state.installation, meta.installation);
        if (!Array.isArray(state.installation.companies)) state.installation.companies = [];
        if (!Array.isArray(state.installation.history)) state.installation.history = [];
        /* CUSTOM_RFQPORTAL_BY_CLAUDE — Same legacy-only auto-promote rule
           as shipping above. instRaw presence = explicit save → honor it. */
        if (!instRaw && state.installation.totalQuoted > 0 && state.fees[1].amount === 0 && state.fees[1].status === 'pending') {
          state.fees[1].amount = state.installation.totalQuoted;
          state.fees[1].status = 'value';
          var instInput2 = wrap.querySelector('.rq-ws-fees__input[data-fee="installation"]');
          var instSel2 = wrap.querySelector('.rq-ws-fees__status[data-fee="installation"]');
          if (instInput2) { instInput2.value = state.fees[1].amount.toFixed(2); instInput2.style.display = ''; }
          if (instSel2) instSel2.value = 'value';
        }
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      }

      // Send settings + lead source from tags or KV metadata
      if (q.tags) {
        var tags;
        if (Array.isArray(q.tags)) {
          tags = q.tags;
        } else if (typeof q.tags === 'string') {
          tags = q.tags.split(',').map(function(t) { return t.trim(); });
        } else if (typeof q.tags === 'object') {
          tags = Object.keys(q.tags).map(function(k) { return k + ':' + q.tags[k]; });
        } else {
          tags = [];
        }
        tags.forEach(function(tag) {
          if (/^[Tt]erms:/.test(tag)) {
            state.send.terms = tag.replace(/^[Tt]erms:/, '');
            var ts = wrap.querySelector('select[data-field="terms"]'); if (ts) ts.value = state.send.terms;
          }
          if (/^[Ll]ead[Tt]ime:/.test(tag)) {
            state.send.leadTime = tag.replace(/^[Ll]ead[Tt]ime:/, '');
            /* CUSTOM_RFQPORTAL_BY_CLAUDE — Custom lead time (e.g. "~7 days")
               won't match any predefined <option> — route to "Other..." +
               populate the custom text input. Same logic as the KV path
               below. */
            var lt = wrap.querySelector('select[data-field="leadTime"]');
            var ltCustom = wrap.querySelector('.rq-ws-leadtime-custom');
            if (lt) {
              var _tagLtVal = state.send.leadTime;
              var _tagLtMatches = Array.prototype.some.call(lt.options, function(o) { return o.value === _tagLtVal && o.value !== '__other'; });
              if (_tagLtMatches) {
                lt.value = _tagLtVal;
                if (ltCustom) { ltCustom.style.display = 'none'; ltCustom.value = ''; }
              } else {
                lt.value = '__other';
                if (ltCustom) { ltCustom.style.display = ''; ltCustom.value = _tagLtVal; }
              }
            }
            /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
          }
          if (tag.startsWith('expires:')) {
            state.send.expiration = tag.replace('expires:', '');
            var ex = wrap.querySelector('[data-field="expiration"]'); if (ex) ex.value = state.send.expiration;
          }
          if (tag.startsWith('leadSource:')) {
            state.leadSource = tag.replace('leadSource:', '');
          }
        });
      }
      // KV metadata overrides for send settings + lead source.
      // Lead-derived quotes (workstation_meta.createdFromLead === true) default
      // to leadSource=inbound + cfaAttribution=none — the customer came to us
      // via a form/sample/phone-call, so attribution starts as inbound with no
      // CFA owner. Rep can change either after the fact.
      if (meta.leadSource) state.leadSource = meta.leadSource;
      else if (meta.createdFromLead && !state.leadSource) state.leadSource = 'inbound';
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — Hydrate the PDF product-links toggle, then
         (deferred so state.items is fully populated + rendered) load any saved
         per-SKU external links so rows show the chip instead of "+ Add link". */
      state.linkProductsOnPdf = !!meta.linkProductsOnPdf;
      state.vendorLabels = (meta.vendorLabels && typeof meta.vendorLabels === 'object') ? meta.vendorLabels : {};
      var _lpBox = wrap.querySelector('[data-field="linkProductsOnPdf"]');
      if (_lpBox) _lpBox.checked = state.linkProductsOnPdf;
      if (state.linkProductsOnPdf && Q.fetchExternalLinks) setTimeout(function() { Q.fetchExternalLinks(); }, 0);
      /* CUSTOM_ROOMDESIGNER_BY_CLAUDE — Hydrate the "add gym layout to PDF"
         toggle + reveal its field only when this quote has a linked floor plan
         (meta.linkedFiles) or a pending design link from a GLD handoff. */
      state.linkedFiles = Array.isArray(meta.linkedFiles) ? meta.linkedFiles : [];
      state.includeLayoutInPdf = !!meta.includeLayoutInPdf;
      state.layoutOverage = !!meta.layoutOverage;
      state.layoutDimensions = !!meta.layoutDimensions;
      if (Q.refreshLayoutPdfToggle) Q.refreshLayoutPdfToggle();
      var resolvedCfa = meta.cfaAttribution || (meta.createdFromLead ? 'none' : null);
      if (resolvedCfa) {
        state.cfaAttribution = resolvedCfa;
        var cfaSel = wrap.querySelector('select[data-field="cfaAttribution"]');
        if (cfaSel) {
          cfaSel.value = state.cfaAttribution;
          syncCustomSelect(cfaSel);
          if (cfaSel.disabled) {
            var cfaCw = wrap.querySelector('.rq-ws-custom-select[data-field="cfaAttribution"]');
            if (cfaCw && cfaCw._btn) cfaCw._btn.textContent = '—';
          }
        }
      }
      if (meta.send) {
        if (meta.send.terms) { state.send.terms = meta.send.terms; var ts2 = wrap.querySelector('select[data-field="terms"]'); if (ts2) { ts2.value = state.send.terms; syncCustomSelect(ts2); } }
        /* CUSTOM_RFQPORTAL_BY_CLAUDE — Lead time hydration. A custom value
           (e.g. "~7 days") won't match any predefined <option>, so setting
           select.value silently fails and the custom select widget renders
           empty. Detect non-matching values and route them to the "Other..."
           option + populate the custom text input. */
        if (meta.send.leadTime) {
          state.send.leadTime = meta.send.leadTime;
          var lt2 = wrap.querySelector('select[data-field="leadTime"]');
          var ltCustom2 = wrap.querySelector('.rq-ws-leadtime-custom');
          if (lt2) {
            var _ltVal = state.send.leadTime;
            var _ltMatches = Array.prototype.some.call(lt2.options, function(o) { return o.value === _ltVal && o.value !== '__other'; });
            if (_ltMatches) {
              lt2.value = _ltVal;
              if (ltCustom2) { ltCustom2.style.display = 'none'; ltCustom2.value = ''; }
            } else {
              lt2.value = '__other';
              if (ltCustom2) { ltCustom2.style.display = ''; ltCustom2.value = _ltVal; }
            }
            syncCustomSelect(lt2);
          }
        }
        /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
        if (meta.send.expiration) { state.send.expiration = meta.send.expiration; var ex2 = wrap.querySelector('[data-field="expiration"]'); if (ex2) ex2.value = state.send.expiration; }
      }
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — Hydrate Sales Rep override (admin
         ghost-author for printed PDF). Stored at meta.salesRepOverride;
         absent on legacy quotes → leave defaults. UI block stays hidden
         for non-admin users regardless of value. */
      if (meta.salesRepOverride) {
        state.salesRepOverride = {
          name: String(meta.salesRepOverride.name || ''),
          phone: String(meta.salesRepOverride.phone || ''),
          email: String(meta.salesRepOverride.email || ''),
        };
        var roN = wrap.querySelector('[data-field="salesRepOverrideName"]');
        var roP = wrap.querySelector('[data-field="salesRepOverridePhone"]');
        var roE = wrap.querySelector('[data-field="salesRepOverrideEmail"]');
        if (roN) roN.value = state.salesRepOverride.name;
        if (roP) roP.value = state.salesRepOverride.phone;
        if (roE) roE.value = state.salesRepOverride.email;
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      /* CUSTOM_RFQPORTAL_BY_CLAUDE — Hydrate Existing Credit (admin-only
         linked-order deposit/credit). Stored at meta.existingCredit;
         absent on legacy quotes → leave defaults. UI block stays hidden
         for non-admin users regardless of value. */
      if (meta.existingCredit) {
        state.existingCredit = {
          amount: parseFloat(meta.existingCredit.amount) || 0,
          sourceRef: String(meta.existingCredit.sourceRef || '').toUpperCase(),
        };
        var ecA = wrap.querySelector('[data-field="existingCreditAmount"]');
        var ecS = wrap.querySelector('[data-field="existingCreditSourceRef"]');
        if (ecA) ecA.value = state.existingCredit.amount > 0 ? Q.fmt(state.existingCredit.amount) : '';
        if (ecS) ecS.value = state.existingCredit.sourceRef;
      }
      /* END CUSTOM_RFQPORTAL_BY_CLAUDE */
      var leadSourceSel = wrap.querySelector('select[data-field="leadSource"]');
      if (leadSourceSel) { leadSourceSel.value = state.leadSource || ''; syncCustomSelect(leadSourceSel); }
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-19) — restore BOTH referral
         boxes. BLOCK A = wm.referral (Shared Deal recipient, paid). BLOCK B =
         wm.referralSource (referral source, tracking). Migration: a pre-split
         tracking referral lived in wm.referral with gpPercent 0 on a non-shared
         deal — move it to referralSource so it shows in BLOCK B and re-saves
         cleanly. */
      var referralIn = (meta && meta.referral) ? meta.referral : null;
      var referralSrcIn = (meta && meta.referralSource) ? meta.referralSource : null;
      if (!referralSrcIn && referralIn && referralIn.name && state.leadSource !== 'shared') {
        referralSrcIn = { name: referralIn.name };
        referralIn = null;
      }
      state.referral = {
        name: (referralIn && referralIn.name) ? String(referralIn.name) : '',
        gpPercent: (referralIn && referralIn.gpPercent != null) ? parseFloat(referralIn.gpPercent) || 0 : 0,
      };
      state.referralSource = { name: (referralSrcIn && referralSrcIn.name) ? String(referralSrcIn.name) : '' };
      var refNameEl = wrap.querySelector('input[data-field="referralName"]');
      var refPctEl = wrap.querySelector('input[data-field="referralGpPercent"]');
      if (refNameEl) refNameEl.value = state.referral.name || '';
      if (refPctEl) refPctEl.value = state.referral.gpPercent ? state.referral.gpPercent : '';
      // BLOCK B ("Referred By") has no input any more (DNI decoupling piece 3) — state.referralSource
      // is hydrated above purely so a legacy value round-trips through a re-save unharmed.
      // Paint the Shared Deal recipient block now that Deal Type is restored.
      if (Q.updateReferralBlockVisibility) Q.updateReferralBlockVisibility();

      // Re-query DOM if elements weren't available yet (new tab before auth reveal)
      if (!dom.itemsContainer) {
        dom.itemsContainer = wrap.querySelector('.rq-ws-items');
        dom.itemsEmpty = wrap.querySelector('.rq-ws-items__empty');
        dom.totalsPanel = wrap.querySelector('.rq-ws-totals');
        dom.totals = {
          msrp: wrap.querySelector('.rq-ws-totals__msrp'),
          discount: wrap.querySelector('.rq-ws-totals__discount'),
          direct: wrap.querySelector('.rq-ws-totals__direct'),
          shipping: wrap.querySelector('.rq-ws-totals__shipping'),
          installation: wrap.querySelector('.rq-ws-totals__installation'),
          tax: wrap.querySelector('.rq-ws-totals__tax'),
          grand: wrap.querySelector('.rq-ws-totals__grand'),
          margin: wrap.querySelector('.rq-ws-totals__margin')
        };
      }

      // Note: vendor color sub redistribution removed — render logic now handles
      // shared vs item-specific display without needing data-level copies between items.

      if (Q.healFreightBaseline) Q.healFreightBaseline(meta, state.ref || ref); // CUSTOM_FREIGHTCHANGERULE_BY_CLAUDE
      Q.renderItems();
      Q.recalcTotals();

      state.loadedGrandTotal = state.lastGrandTotal;
      state.pdfDownloaded = !!meta.pdfDownloaded;
      // Restore the once-per-quote E-Cleaner prompt flags so a reloaded
      // quote doesn't re-prompt on save/download if it was already shown.
      state.eCleanerPromptedOnSave = !!meta.eCleanerPromptedOnSave;
      state.eCleanerPromptedOnDownload = !!meta.eCleanerPromptedOnDownload;
      state.dirty = false;
      Q.updateSaveButton();

      // Auto-expand line items section when loading an existing quote
      var itemsSection = wrap.querySelector('.rq-ws-section--items .rq-ws-section__body');
      var itemsIcon = wrap.querySelector('.rq-ws-section--items .rq-ws-section__toggle-icon');
      if (itemsSection && !itemsSection.classList.contains('rq-ws-section__body--open')) {
        itemsSection.classList.add('rq-ws-section__body--open');
        itemsSection.style.maxHeight = 'none';
        itemsSection.style.overflow = 'visible';
        if (itemsIcon) itemsIcon.textContent = '−';
      }

      // Render freight/installation panels if admin
      if (isAdmin) {
        Q.renderFreightVendors();
        Q.renderInstallCompanies();
      }
      // Repaint the delivery-conditions exception callout in Fees & Extras.
      // Default (no flags set) → hidden; otherwise it surfaces the rep's
      // chosen exceptions so admin can't miss them when quoting freight.
      if (Q.renderDeliveryHighlight) Q.renderDeliveryHighlight();
      // And repaint the order-level flags in the admin freight panel.
      if (Q.renderFreightDeliveryFlags) Q.renderFreightDeliveryFlags();
      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-26) - the installation scope flags repaint on
         load for the same reason the freight ones do: the checkboxes are painted FROM state,
         so a loaded quote that already has a scope would otherwise show two empty boxes and
         the first click would read as setting it rather than changing it. */
      if (Q.renderInstallScopeFlags) Q.renderInstallScopeFlags();

      // Update fee dropdown options (role-aware) and request button
      Q.updateFeeDropdownOptions();
      // Quote age counter
      Q.updateQuoteAge(q.createdAt || q.created_at);
      Q.updateBarCustomer();
      Q.fetchEmailSentLog(ref);

      if (Q.fillDeliveryWindow) Q.fillDeliveryWindow(data.customerWindow || null); // CUSTOM_QUOTEDWINDOW_BY_CLAUDE (ONYX 0b837ff9363b)

      // Lock workstation if quote is sold (admins can still edit)
      if (data.lifecycleStatus === 'sold' && !isAdmin) {
        lockWorkstation('SOLD — Read Only');
      } else {
        unlockWorkstation();
      }

      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-08-21) — REPLACEMENT MODE.
         A replacement order (RPL-*) is a $0 re-ship of goods the customer already
         paid for. The admin edits QUANTITY and COST — the cost is what the supplier
         PO is built from, and what the company eats until the carrier claim pays —
         but can never put a PRICE on it.

         ⛔ This is an affordance, not the guarantee. The real lock is server-side in
         handleSaveWorkstation, which coerces points/directPrice to 0 on every save
         regardless of what the client posts. A stale tab or a replayed request must
         not be able to price a replacement, and greying an input cannot promise that.

         Applied AFTER the sold-lock branch above so unlockWorkstation() (which runs on
         the else path) cannot strip it. */
      var _wmR = data.workstationMeta || {};
      state.isReplacement = !!(_wmR.replacementParentRef || /^RPL-\d+-[A-Z]$/i.test(ref || ''));
      state.replacementParentRef = _wmR.replacementParentRef || '';
      state.replacementReason = _wmR.replacementReason || '';
      state.replacementCandidates = Array.isArray(_wmR.replacementCandidates) ? _wmR.replacementCandidates : [];
      if (state.isReplacement) {
        applyReplacementMode();
      } else {
        wrap.classList.remove('rq-ws--replacement');
        /* Loading a normal quote into a tab that had a replacement open must clear the
           parent chip — it is display state, not a class, so the class removal above
           cannot take it with it. */
        renderReplacementFor();
      }

      // Update URL
      if (window.history.replaceState) {
        window.history.replaceState(null, '', window.location.pathname + '?ref=' + encodeURIComponent(ref));
      }

      /* CUSTOM_RFQPORTAL_BY_CLAUDE (Ryan 2026-06-22) — clear dirty and ARM normal
         tracking on the rep's first genuine interaction. While suppressed (above), any
         load/render/recalc dirty=true is ignored; the first real isTrusted input/change/
         keydown inside the form clears suppression so real edits track normally.
         Programmatic dispatches (isTrusted=false) are ignored. (Import/revision flows
         set dirty AFTER loadQuote resolves + after a real flow, so they're unaffected.) */
      state.dirty = false;
      if (Q.updateSaveButton) Q.updateSaveButton();
      var _armEvts = ['input', 'change', 'keydown'];
      if (state._armEditHandler) { _armEvts.forEach(function (t) { wrap.removeEventListener(t, state._armEditHandler, true); }); }
      state._armEditHandler = function (e) {
        if (e && e.isTrusted === false) return; // ignore programmatic load/render dispatches
        state.suppressDirty = false;
        _armEvts.forEach(function (t) { wrap.removeEventListener(t, state._armEditHandler, true); });
      };
      _armEvts.forEach(function (t) { wrap.addEventListener(t, state._armEditHandler, true); });
    }).catch(function(err) {
      dom.barStatus.style.display = 'none';
      console.error('Load quote error:', err);
    });
  }

  /* ── Exports ── */
  Q.loadQuotesList = loadQuotesList;
  Q.loadQuote = loadQuote;
  Q.lockWorkstation = lockWorkstation;
  Q.renderReplacementFor = renderReplacementFor;
  Q.unlockWorkstation = unlockWorkstation;
  Q.toggleLoadDropdown = toggleLoadDropdown;
  Q.filterQuotesList = filterQuotesList;
})();
